const NEW_OBJECT_PAGE_PATH = /^\/(search\/)?artifact\/[^/]/;

/** ObjectPageV2Component is routed at both `/search/artifact/:id` and `/artifact/:id`. */
export function isNewObjectPagePath(pathname: string | null | undefined): boolean {
  return !!pathname && NEW_OBJECT_PAGE_PATH.test(pathname);
}
